module.exports = __webpack_public_path__ + "static/hyperv_19.2eaa2d96.jpg";